module.exports = __webpack_public_path__ + "img/aggregation.1fbcf784.png";